import { Loadable } from 'foundations-components/transitional/utils/Loadable';
import AsyncComponentErrorHandler from '../../shared/components/AsyncComponentErrorHandler';
export const ListingLibFiltersBar = Loadable({
  loader: () => import( /* webpackChunkName: "filters-next" */'./ListingLibFiltersBar').then(mod => mod.ListingLibFiltersBar).catch(AsyncComponentErrorHandler('filters-next')),
  LoadingComponent: () => null
});